import { createSlice } from "@reduxjs/toolkit";

const mySlice = createSlice({
  name: "setting",
  initialState: {
    isFetching: false,
    isCreating: false,
    all: { data: [] },
    new: null,
  },
  reducers: {
    setIsFetching(state, action) {
      state.isFetching = action.payload;
    },
    setIsCreating(state, action) {
      state.isCreating = action.payload;
    },
    setNew(state, action) {
      state.new = action.payload;
    },
  },
});

export const mySettingActions = mySlice.actions;

export default mySlice.reducer;
